import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import {
  answerTransferPrompt,
  subscribeTransferNotice,
  subscribeTransferPrompt,
  type TransferMode,
  type TransferRequest,
} from '../lib/transferPolicy';

function formatSize(bytes: number | null): string {
  if (bytes == null || bytes < 0) return i18n.t('misc:transferUnknownSize');
  if (bytes >= 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MiB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KiB`;
}

export default function TransferPolicyPrompt() {
  const { t } = useTranslation('misc');
  const [request, setRequest] = useState<TransferRequest | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  useEffect(() => {
    const unsubscribePrompt = subscribeTransferPrompt(setRequest);
    const unsubscribeNotice = subscribeTransferNotice(setNotice);
    return () => { unsubscribePrompt(); unsubscribeNotice(); };
  }, []);
  if (!request && !notice) return null;

  const action = request?.direction === 'upload' ? t('transferUpload') : t('transferDownload');
  const choose = (mode: TransferMode) => answerTransferPrompt(mode);

  return (
    <>
      {notice && <div role="status" style={{ position: 'fixed', left: '50%', bottom: 24, transform: 'translateX(-50%)', zIndex: 10001, maxWidth: 'min(90vw, 560px)', padding: '10px 16px', borderRadius: 10, background: 'var(--card)', boxShadow: '0 4px 24px #0005' }}>{notice}</div>}
      {request && (
        <div className="modal-backdrop">
          <div className="modal transfer-policy-modal" role="dialog" aria-modal="true" aria-labelledby="transfer-policy-title">
            <button type="button" className="modal-close" title={t('transferClose')} onClick={() => answerTransferPrompt(null)}>✕</button>
            <h2 id="transfer-policy-title">{t('transferTitle')}</h2>
            <p>
              {t('transferDescription', { action, label: request.label, size: formatSize(request.sizeBytes) })}
            </p>
            <div className="transfer-policy-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button type="button" className="btn btn-ghost" onClick={() => choose('wifi-only')}>{t('transferWifiOnly')}</button>
              <button type="button" className="btn" onClick={() => choose('allow-cellular')}>{t('transferAllowCellular')}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
